const features = [
  {
    icon: 'ri-music-line',
    title: '海量高品质内容',
    description: '超过 2,000 个精心制作的 ASMR 音频，涵盖耳语、自然、角色扮演等多元场景。',
  },
  {
    icon: 'ri-headphone-line',
    title: '专业录音设备',
    description: '采用专业双耳录音技术，搭配高灵敏度麦克风，还原最真实的音频细节。',
  },
  {
    icon: 'ri-moon-line',
    title: '科学助眠方案',
    description: '基于声学心理学原理设计，帮助调节脑波频率，引导进入深度放松状态。',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '缓解焦虑压力',
    description: '经用户反馈验证，定期聆听可显著降低皮质醇水平，有效缓解日常焦虑情绪。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            为什么选择 asmrone
          </h2>
          <p className="text-base text-foreground-600 max-w-xl mx-auto">
            我们致力于打造极致的沉浸式音频体验，用专业和用心守护你的每一刻宁静
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 md:p-8 rounded-lg bg-background-100/70 border border-background-200/60 hover:border-primary-200/50 transition-all"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-5 group-hover:scale-110 transition-transform">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}